module.exports = __webpack_public_path__ + "static/img/8.a124170.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/8.jpg
// module id = 0BAp
// module chunks = 1